export const CACHE_CONFIG = {
  EMPLOYEE_LIST: {
    url: "/EmployeeManagement/GetEmployeeList",
    method: "GET",
    duration: 180,
    description: "Fetch all employees",
  },
  EMPLOYEE_GET_FACE_DATA: {
    url: "/EmployeeManagement/getFaceData",
    method: "GET",
    duration: 0,
    description: "Employee Face Data",
  },
  EMPLOYEE_GET_VALIDATION_REQUIREMENTS: {
    url: "/EmployeeManagement/employeeValidations",
    method: "GET",
    duration: 0,
    description: "Employee Validation Requirements",
  },
  EMPLOYEE_POST_VALIDATION_REQUIREMENTS: {
    url: "/EmployeeManagement/employeeValidation",
    method: "POST",
    duration: 180,
    description: "Employee Validation Requirements",
  },
  EMPLOYEE_GET_DETAILED_SESSION_LOG: {
    url: "/EmployeeManagement/userSessionLogDetailed",
    method: "GET",
    duration: 180,
    description: "Employee Session Logs",
  },
    EMPLOYEE_POST_FACE_STATUS: {
    url: "/EmployeeManagement/updateUserFaceStatus",
    method: "POST",
    duration: 0,
    description: "Update face validation status",
  },
  EMPLOYEE_GET_ATTENDANCE_LOGS: {
    url: "/AttendanceManager/attendanceLogsWithLocation",
    method: "GET",
    duration: 180,
    description: "Employee Session Logs",
  },
  EMPLOYEE_GET_ATTENDANCE_LOGS_DETAILED: {
    url: "/AttendanceManager/detailedAttendanceLogs",
    method: "GET",
    duration: 180,
    description: "Employee Session Logs",
  },
  EMPLOYEE_GET_ASSIGNED_LOCATIONS: {
    url: "/EmployeeManagement/assignedLocations",
    method: "GET",
    duration: 180,
    description: "Employee Assigned Locations",
  },
  EMPLOYEE_DELETE_ASSIGNED_LOCATION: {
    url: "/EmployeeManagement/deleteUserLocationMapping",
    method: "DELETE",
    duration: 0,
    description: "Delete Employee Assigned Location",
  },
  EMPLOYEE_POST_ASSIGN_LOCATION: {
    url: "/EmployeeManagement/assignLocation",
    method: "POST",
    duration: 0,
    description: "Employee Assign Location",
  },
  LANGUAGE_GET_LIST: {
    url: "/LanguageManagement/GetLanguageInfo",
    method: "GET",
    duration: 60,
    description: "List of LANGUAGEs",
  },
  REPORTS_GET_DEVICE_LOG: {
    url: "/Report/deviceInfoLogs",
    method: "GET",
    duration: 180,
    description: "Device Info Logs",
  },
  REPORTS_GET_VALIDATION_LOG: {
    url: "/Report/faceValidationData",
    method: "GET",
    duration: 30,
    description: "Device Info Logs",
  },
  REPORTS_GET_EMPLOYEE_VALIDATION_DATA: {
    url: "/Report/employeeValidationData",
    method: "GET",
    duration: 30,
    description: "Device Info Logs",
  },
  REPORTS_GET_EMPLOYEE_VALIDATION_DATA_LOGS: {
    url: "/Report/validationLogs",
    method: "GET",
    duration: 30,
    description: "Device Info Logs",
  },
    REPORTS_GET_FAILED_LOGIN_ATTEMPTS: {
    url: "/Report/failedLoginData",
    method: "GET",
    duration: 30,
    description: "Failed login atteempts Logs",
  },
  CONFIG_GET_LOCATION_MASTER: {
    url: "/EmployeeManagement/LocationMaster",
    method: "GET",
    duration: 180,
    description: "Location Master",
  },
  CONFIG_GET_SYNC_STATUS: {
    url: "/Configuration/apiDataSyncManager",
    method: "GET",
    duration: 180,
    description: "Sync Status",
  },
  CONFIG_GET_ADMIN_ACCESS_LIST: {
    url: "/Configuration/adminUsersList",
    method: "GET",
    duration: 0,
    description: "Admin User Access List",
  },
  CONFIG_GET_ADMIN_ACCESS_PROJECT_LIST: {
    url: "/Configuration/projectList",
    method: "GET",
    duration: 180,
    description: "Admin User Access List Projects List",
  },
  CONFIG_GET_ADMIN_BUSINESS_VERTICAL_LIST: {
    url: "/Configuration/businessVerticals",
    method: "GET",
    duration: 180,
    description: "Admin User Access List Projects List",
  },
  CONFIG_GET_ADMIN_ACCESS_EMP_IDS: {
    url: "/Configuration/employee-ids",
    method: "GET",
    duration: 180,
    description: "User List to add as admin",
  },
  CONFIG_POST_ADMIN_ACCESS_USERDATA: {
    url: "/Configuration/saveAdminAccessConfiguration",
    method: "POST",
    duration: 0,
    description: "Save admin access configuration",
  },

  DASHBOARD_GET_BUSINESS_VERTICAL_COUNTS: {
    url: "/Dashboard/dashboardCounts",
    method: "GET",
    duration: 180,
    description: "Business Vertical Counts",
  },
  DASHBOARD_GET_CHECKIN_STATS: {
    url: "/Dashboard/checkinStats",
    method: "GET",
    duration: 180,
    description: "Business Vertical Counts",
  },
  DASHBOARD_GET_CHECKIN_STATS_BY_HOUR: {
    url: "/Dashboard/userActivityByHour",
    method: "GET",
    duration: 180,
    description: "Business Vertical Counts",
  },
    DASHBOARD_GET_BV_CHECKIN_STATs: {
    url: "/Dashboard/BV_CheckinStats",
    method: "GET",
    duration: 180,
    description: "Business Vertical Counts",
  },
  USER_POST: {
    url: "/users",
    method: "POST",
    duration: 30,
    description: "Create or filter users",
  },
  CONFIG_POST_SYNC_NOW: {
    url: "/Configuration/syncNow",
    method: "POST",
    duration: 0,
    description: "Trigger sync now",
  },
};
